module.exports = "/images/schoolsystem.png?3308b9bcbcc19e94afbffee269790583";